<template>
    <div>
        <h3 class="font-title shop__filters__heading">{{ title }}</h3>
        <ul>
            <li v-for="(category, key) in categories" :key="key">
                <checkbox
                    :option="category"
                    @optionSelect="optionSelect"
                    :shopCheckbox="true"
                    :initialValue="isCategorySelected(category)">
                    <div>
                        {{ category }}
                        <span class="shop__checkbox__label__icon">
                            <img src="@/assets/images/decoration/tick-shop.svg"/>
                        </span>
                    </div>
                </checkbox>
                <hr v-if="dividers">
            </li>
        </ul>
        <button class="shop__filters__clear-button" v-text="$t('FILTER_CLEAR_FILTER')" @click="clear"></button>
    </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex';
import Checkbox from '@/components/forms/fields/Checkbox';

export default {
    name: 'Filters',
    components: {
        Checkbox,
    },
    computed: {
        ...mapGetters({
            checked: 'shop/getCheckedCategories',
        }),
    },
    methods: {
        optionSelect(option, bool) {
            if (bool) {
                this.pushCategory(option);
            } else {
                this.removeCategory(option);
            }
            this.$emit('input', this.checked);
        },
        clear() {
            this.checked = [];
            this.$emit('input', this.checked);
            this.$emit('clear', this.checked);
        },
        ...mapActions({
            pushCategory: 'shop/addCheckedCategory',
        }),
        ...mapMutations({
            removeCategory: 'shop/removeCheckedCategory',
        }),
        isCategorySelected(filter) {
            const isChecked = this.checked.includes(filter);
            return isChecked;
        },
    },
    props: {
        title: {
            required: false,
            type: String,
        },
        categories: {
            required: false,
            type: Set,
        },
        dividers: {
            required: false,
            type: Boolean,
        },
    },
};
</script>
